import { ActionTypes } from "../Constants/ActionTypes";

export const openSuccessPopup = (dispatch, popupInformation) => {
  dispatch({
    type: ActionTypes.OPEN_SUCCESS_POPUP,
    payload: popupInformation,
  });
};

export const closeSuccessPopup = (dispatch, status) => {
  dispatch({
    type: ActionTypes.CLOSE_SUCCESS_POPUP,
    payload: status,
  });
};

export const openRenamePopup = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.OPEN_RENAME_POPUP,
    payload: payload,
  });
};

export const closeRenamePopup = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.CLOSE_RENAME_POPUP,
    payload: payload,
  });
};

export const renameVideoInformation = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.RENAME_VIDEO_INFORMATION,
    payload: payload,
  });
};

export const openConfirmationPopup = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.OPEN_CONFIRMATION_POPUP,
    payload: payload,
  });
};

export const closeConfirmationPopup = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.CLOSE_CONFIRMATION_POPUP,
    payload: payload,
  });
};

export const openVideoPopup = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.OPEN_VIDEO_POPUP,
    payload: payload,
  });
};

export const closeVideoPopup = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.CLOSE_VIDEO_POPUP,
    payload: payload,
  });
};

export const openFailDialog = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.OPEN_FAIL_DIALOG,
    payload: payload,
  });
};

export const closeFailDialog = (dispatch, payload) => {
  dispatch({
    type: ActionTypes.CLOSE_FAIL_DIALOG,
    payload: payload,
  });
};
